import React, { useState } from 'react'
import Input from '../../common/Input'
import Button from '../../common/Button'
import { postRequest, setToken } from '../../apis/functions'
import APIS from '../../apis/routes'
import { Link, useNavigate } from 'react-router-dom'
import { toaster } from '../../apis/commonFunctions'
import { useDispatch } from 'react-redux'
import { setDetails } from '../../redux/slices/detailsSlice'
import toast from 'react-hot-toast'

export default function Login_Signup() {
    const router = useNavigate();
    const dispatcher = useDispatch();
    const [loader, setLoader] = useState(false);
    const [login, setLogin] = useState({
        email: "",
        password: ""
    });

    const handleKeyDown = (e) => {
        if (e.key === " ") {
            e.preventDefault();
        }
    };

    function handleChanges(e) {
        setLogin({
            ...login,
            [e.target.name]: e.target.value.trim()
        })
    }

    async function submitForm(event) {
        event.preventDefault()
        try {
            setLoader(true);
            const result = await postRequest(APIS.LOGIN, login)
            if (!result.data.status) {
                if (result.data.code === 203) {
                    localStorage.clear()
                    router('/login')
                }
                setLoader(false);
                toast.error(result.data.message)
            } else {
                localStorage.setItem('x_token', result.data.data.token)
                setToken(result.data.data.token)
                router('/')
                dispatcher(setDetails(result.data.data.user));
                localStorage.setItem('info',JSON.stringify(result.data.data.user))
            }
        } catch (err) {
            setLoader(false)
            toast.error(err.message)
        }
    };

    return (
        <>
            <div className="container">
                <div className="row align-items-center h-100vh">
                    <div className="col-lg-5 col-md-5">
                        <div className="login_area">
                            {/* <div className="logo"><img src="/logo.png" alt="logo" className='img-fluid' /></div> */}
                            <p className='mt-3'>Administrator Login</p>
                            <form onSubmit={submitForm}>
                                <div className="mt-5">
                                    <div className="group">
                                        <Input required={true} className={'mt-2'} type={'text'} id={'text'} onChange={handleChanges} onKeyDown={handleKeyDown} autoComplete={'off'} placeholder={'abc@example.com'} value={login.email} name="email" label={'Email'} />
                                    </div>
                                    <div className="group mt-4">
                                        <Input required={true} className={'mt-2'} value={login.password} id={'password'} type={'password'} name="password" onKeyDown={handleKeyDown} placeholder='********' onChange={handleChanges} label={'Password'} />
                                    </div>
                                    <div className="text-end forget">
                                        <Link to='/forgot-password'>Forgot Password</Link>
                                    </div>
                                    <div className="site_btn mt-5">
                                        <Button loader={loader} type="submit" text={'Login'} />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-7 mobile_hide">
                        <div className="center_img text-center">
                            <img src="/login-img.png" alt="" className='img-fluid' />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}